import { u as Me, j as s, L as D } from "./index2.mjs";
import { l as U, m as ze, n as K, o as S, p as ue, q as z, r as k, t as pe, u as ke, v as fe, w as _, x as B, y as P, z as Pe, A as Re, B as R, C as F, D as q, E as He, F as w, G as te, H as E, I as H, J as ne } from "./style.css.mjs";
import * as h from "react";
import ie, { forwardRef as A, useState as J, useEffect as Ne, useRef as xe, useMemo as Ve, Fragment as ye, useCallback as Be } from "react";
import { CLICK_CODE_ATTRIBUTE_NAME as x } from "../constants/index.mjs";
import { u as Y } from "./useAirport.mjs";
import { g as be } from "./index.mjs";
var Ae = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function a() {
      for (var i = "", l = 0; l < arguments.length; l++) {
        var c = arguments[l];
        c && (i = r(i, n(c)));
      }
      return i;
    }
    function n(i) {
      if (typeof i == "string" || typeof i == "number")
        return i;
      if (typeof i != "object")
        return "";
      if (Array.isArray(i))
        return a.apply(null, i);
      if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
        return i.toString();
      var l = "";
      for (var c in i)
        t.call(i, c) && i[c] && (l = r(l, c));
      return l;
    }
    function r(i, l) {
      return l ? i ? i + " " + l : i + l : i;
    }
    e.exports ? (a.default = a, e.exports = a) : window.classNames = a;
  })();
})(Ae);
var Fe = Ae.exports;
const u = /* @__PURE__ */ be(Fe), b = /* @__PURE__ */ A(({ children: e, href: t, onClick: a, ...n }, r) => {
  const i = Me();
  return /* @__PURE__ */ s.jsx(i, { role: "button", ref: r, href: t, onClick: a, ...n, children: e });
}), Ie = (e) => /* @__PURE__ */ h.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 14 14", ...e }, /* @__PURE__ */ h.createElement("path", { d: "M0 0c2.462 9.333 7.129 14 14 14H0V0z" })), Ye = (e) => /* @__PURE__ */ h.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 13 13", ...e }, /* @__PURE__ */ h.createElement("path", { d: "M7.6,11.9l-1-0.9l3.9-3.9H0.1V5.8h10.4L6.6,2l1-0.9l5.4,5.5L7.6,11.9z" })), Ge = (e) => /* @__PURE__ */ h.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 6 11", ...e }, /* @__PURE__ */ h.createElement("path", { d: "M.4.4c.2-.2.6-.2.8 0l4.5 4.7c.2.2.2.6 0 .8l-4.5 4.7c-.2.2-.6.2-.8 0-.2-.2-.2-.6 0-.8l4.1-4.3L.4 1.2C.1 1 .1.6.4.4z" })), We = (e) => /* @__PURE__ */ h.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 6 12", ...e }, /* @__PURE__ */ h.createElement("path", { d: "M4.516 6L0 10.773l.796.727L6 6 .796.5 0 1.227z" })), Ue = (e) => /* @__PURE__ */ h.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 13 8", ...e }, /* @__PURE__ */ h.createElement("path", { d: "M6.5,7.7L0.1,1.4l0.7-0.7l5.6,5.6l5.6-5.6l0.7,0.7L6.5,7.7z" })), Ke = (e) => /* @__PURE__ */ h.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 12 12", ...e }, /* @__PURE__ */ h.createElement("path", { d: "M11.3 12 6 6.7.7 12l-.7-.7L5.3 6 0 .7.7 0 6 5.3 11.3 0l.7.7L6.7 6l5.3 5.3z" })), qe = (e) => /* @__PURE__ */ h.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...e }, /* @__PURE__ */ h.createElement("path", { d: "M8.7,4.5c0,0.4-0.3,0.7-0.7,0.7S7.3,4.9,7.3,4.5S7.6,3.8,8,3.8S8.7,4.1,8.7,4.5z M7.5,12.5h1v-6h-1V12.5z M15.5,8 c0,4.1-3.4,7.5-7.5,7.5S0.5,12.1,0.5,8S3.9,0.5,8,0.5S15.5,3.9,15.5,8z M14.5,8c0-3.6-2.9-6.5-6.5-6.5S1.5,4.4,1.5,8 s2.9,6.5,6.5,6.5S14.5,11.6,14.5,8z" })), Ze = (e) => /* @__PURE__ */ h.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 18 18", ...e }, /* @__PURE__ */ h.createElement("path", { fillRule: "evenodd", d: "M9.1 1c4.467 0 8.1 3.634 8.1 8.1 0 4.467-3.633 8.1-8.1 8.1-4.466 0-8.1-3.633-8.1-8.1C1 4.634 4.634 1 9.1 1zm0 1.2c-3.805 0-6.9 3.095-6.9 6.9S5.295 16 9.1 16 16 12.905 16 9.1s-3.095-6.9-6.9-6.9zm0 9.3c.552 0 1 .447 1 1 0 .553-.448 1-1 1s-1-.447-1-1c0-.553.448-1 1-1zm.315-6.742c.443 0 .8.359.8.8 0 .027 0 .054-.004.08L9.787 9.86c-.03.306-.289.54-.596.54H9.01c-.307 0-.566-.234-.596-.54l-.425-4.221c-.044-.44.277-.833.716-.877.027-.002.053-.003.081-.003h.63z" })), Je = (e) => /* @__PURE__ */ h.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 14 14", ...e }, /* @__PURE__ */ h.createElement("path", { d: "M7.7.5C7.7.2 7.3 0 7 0s-.6.2-.7.5L5 4.5H.7c-.3 0-.6.2-.7.5 0 .3 0 .6.3.8l3.5 2.5-1.3 4.1c0 .3 0 .6.3.8.1 0 .3.1.4.1s.3 0 .4-.1l3.5-2.5 3.5 2.5c.3.2.6.2.8 0 .3-.2.4-.5.3-.8l-1.3-4.1 3.5-2.5c.3-.2.4-.5.3-.8 0-.3-.3-.5-.6-.5H9.3L7.7.5z" })), Qe = (e) => /* @__PURE__ */ h.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 36, height: 16, viewBox: "0 0 36 16", ...e }, /* @__PURE__ */ h.createElement("path", { fill: "#f0f7f4", className: "pui__label_bg", d: "M12 1h23c.6 0 1 .4 1 1v11c0 .6-.4 1-1 1H12V1z" }), /* @__PURE__ */ h.createElement("path", { fill: "#fff", className: "pui__label_icon_inner", d: "M12.1 13.1V2.8H.9v10.3h11.2z" }), /* @__PURE__ */ h.createElement("path", { fill: "#059e4a", className: "pui__label_icon_stroke", d: "M9 0c-.2 0-.4.2-.4.5V1h-4V.5C4.5.2 4.3 0 4 0s-.5.2-.5.5V1H1c-.6 0-1 .4-1 1v11c0 .6.4 1 1 1h11c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1H9.5V.5C9.5.2 9.3 0 9 0zm3.1 2.8v10.3H.9V2.8h11.2zM5.4 7.7l2.2 2.9h1.8V5.2H7.6v2.9L5.4 5.2H3.6v5.5h1.8v-3zM20.2 6c.1.3.1.7.1 1.1 0 .3 0 .7-.1.9h.9V6h-.9zm-1.8 3.3c.6 0 1-.9 1-2.2s-.3-2.3-1-2.3c-.6 0-1 1-1 2.3s.3 2.2 1 2.2zm5.5-6.2v9h-1v-9h1zm-2.8 8.6V8.8H20c-.3.8-.8 1.4-1.7 1.4-1.3 0-1.9-1.5-1.9-3.2 0-1.7.6-3.1 1.9-3.1.8 0 1.3.5 1.6 1.3h1.2V3.3h1v8.4h-1zM26.9 7c.8 0 1.3-.6 1.3-1.3 0-.7-.5-1.3-1.3-1.3s-1.3.6-1.3 1.3c0 .8.5 1.3 1.3 1.3zm-1.2 2.7v-.9h5.9v3.3h-1V9.7h-4.9zm5.8-3.4h1.3v.8h-1.3v1.2h-1V3.1h1v1.1h1.3V5h-1.3v1.3zm-4.6-2.7c1.3 0 2.3.9 2.3 2.1 0 1.3-1 2.1-2.3 2.1-1.3 0-2.3-.8-2.3-2.1 0-1.2 1-2.1 2.3-2.1z" })), Xe = (e) => /* @__PURE__ */ h.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 41, height: 16, viewBox: "0 0 41 16", ...e }, /* @__PURE__ */ h.createElement("path", { fill: "#f0f7f4", className: "pui__label_bg", d: "M12 1.004 40 1a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1l-28 .004z" }), /* @__PURE__ */ h.createElement("path", { fill: "#fff", className: "pui__label_icon_inner", d: "M12.5 13.08V2.77H.5v10.31z" }), /* @__PURE__ */ h.createElement("path", { fill: "#059e4a", className: "pui__label_icon_stroke", d: "M8.555.466a.476.476 0 0 1 .952.02L9.496 1H12a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h2.497V.5a.5.5 0 0 1 1 0V1h4.046zm3.548 12.604V2.761H.897v10.31zm-4.527-2.393L5.424 7.732v2.945H3.631V5.155h1.793L7.576 8.1V5.155h1.793v5.522zm26.268.473V3.747h1.216V8h.083l1.967-2.187h1.407l-2.149 2.255 2.295 3.082h-1.465l-1.714-2.31-.424.434v1.876zm-5.906-2.667c0 1.729.966 2.774 2.568 2.774 1.597 0 2.568-1.045 2.568-2.774v-.01c0-1.718-.976-2.763-2.568-2.763-1.587 0-2.568 1.05-2.568 2.764zm3.891.005c0 1.123-.478 1.783-1.323 1.783s-1.328-.66-1.328-1.783v-.01c0-1.122.483-1.787 1.328-1.787.84 0 1.323.665 1.323 1.788zm-6.917 2.769c-1.601 0-2.568-1.045-2.568-2.774v-.01c0-1.713.981-2.763 2.568-2.763 1.592 0 2.569 1.045 2.569 2.764v.01c0 1.728-.972 2.773-2.569 2.773zm0-.986c.845 0 1.323-.66 1.323-1.783v-.01c0-1.122-.483-1.787-1.323-1.787-.845 0-1.328.665-1.328 1.788v.01c0 1.122.483 1.782 1.328 1.782zm-8.484-6.167v7.046h3.013c1.504 0 2.421-.762 2.421-1.998v-.01c0-.912-.654-1.596-1.601-1.684V7.37c.708-.112 1.255-.766 1.255-1.504v-.01c0-1.079-.806-1.752-2.144-1.752zm1.26.981h1.377c.761 0 1.206.366 1.206.991v.01c0 .64-.474.986-1.368.986h-1.215zm0 2.88h1.416c.962 0 1.47.377 1.47 1.09v.01c0 .717-.494 1.103-1.422 1.103h-1.464z" })), Te = (e) => /* @__PURE__ */ h.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...e }, /* @__PURE__ */ h.createElement("path", { fill: "#00a2ff", d: "M11.2 10.9c-.7 1.2-2.3 2.2-3.7 2.2V.7h-1C2.7.7 1.7.8 0 .3c0 0 0 1.6 1.8 2.5 0 0 .1 0 .4.2C.8 4.4 0 6.2 0 8.2v7.5h7.5c2.5 0 4.7-1.4 5.9-3.4l-2.2-1.4z" }), /* @__PURE__ */ h.createElement("path", { fill: "#fafdfd", d: "M7.5 13c-2.7 0-4.8-2.2-4.8-4.8s2.1-4.8 4.8-4.8" }), /* @__PURE__ */ h.createElement("path", { fill: "#1eda69", d: "M7.5.7v7.8h7.8c0-4.3-3.5-7.8-7.8-7.8z" }), /* @__PURE__ */ h.createElement("path", { fill: "#50505f", d: "M5.3 8.5c.6 0 1.1-.5 1.1-1.1s-.5-1.1-1.1-1.1-1.1.5-1.1 1.1.5 1.1 1.1 1.1z" }), /* @__PURE__ */ h.createElement("path", { fill: "#ffc600", d: "M7.5 8.5V13c1.5 0 3-1 3.7-2.2L7.5 8.4z" })), $e = (e) => /* @__PURE__ */ h.createElement("svg", { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ h.createElement("path", { d: "M9.70666 2.17085C9.74671 2.0495 9.84529 1.98018 9.98361 1.97984L9.70666 2.17085ZM9.70666 2.17085L7.8659 7.7694L1.87133 7.78437C1.71953 7.7848 1.63015 7.86675 1.59424 7.976C1.57551 8.03297 1.57596 8.0882 1.58946 8.13305C1.60141 8.17274 1.62824 8.22146 1.69623 8.26955L6.5681 11.7174L4.72372 17.327C4.69988 17.3994 4.70652 17.451 4.72091 17.4899C4.73735 17.5345 4.77187 17.5822 4.82566 17.6203C4.9322 17.6956 5.06054 17.7038 5.17846 17.6194L10.0162 14.1579L14.872 17.5947C14.9903 17.6785 15.1186 17.6699 15.2247 17.5941C15.2782 17.5557 15.3125 17.5078 15.3288 17.4631C15.343 17.424 15.3495 17.3724 15.3252 17.2999L13.4511 11.7L18.3042 8.22754C18.3042 8.22751 18.3042 8.22756 18.3042 8.22754C18.3719 8.17908 18.3985 8.13012 18.4103 8.09028C18.4236 8.04526 18.4237 7.98994 18.4047 7.93302C18.3682 7.8239 18.2784 7.74256 18.1267 7.743L12.132 7.75844L10.2617 2.16986C10.2617 2.16985 10.2617 2.16988 10.2617 2.16986C10.221 2.04841 10.122 1.97949 9.98361 1.97984M8.37678 1.73332C8.88175 0.199412 11.0766 0.193902 11.5893 1.72545L13.1389 6.35584L18.1227 6.343C18.1228 6.343 18.1227 6.343 18.1227 6.343C19.7304 6.33858 20.475 8.3954 19.1191 9.36596L15.107 12.2366L16.6528 16.8555C16.6528 16.8556 16.6528 16.8555 16.6528 16.8555C17.1835 18.4411 15.3492 19.6483 14.0632 18.7375C14.0631 18.7374 14.0633 18.7375 14.0632 18.7375L10.0206 15.8762L5.99332 18.7578C5.99329 18.7578 5.99336 18.7578 5.99332 18.7578C4.71272 19.6743 2.87097 18.4784 3.39376 16.8897C3.39379 16.8896 3.39373 16.8898 3.39376 16.8897L4.91508 12.2627L0.887756 9.41252C-0.47431 8.44907 0.260566 6.38896 1.86734 6.38437L6.85165 6.37193L8.37678 1.73332Z" })), es = (e) => /* @__PURE__ */ h.createElement("svg", { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ h.createElement("path", { d: "M11.4943 1.75705C11.0122 0.316741 8.94652 0.321941 8.47165 1.76444L6.92398 6.4716L1.8675 6.48422C0.353215 6.48854 -0.333203 8.42633 0.945387 9.33073L5.03304 12.2236L3.48871 16.9205C2.9983 18.4102 4.72661 19.5413 5.935 18.6763L10.0201 15.7533L14.1209 18.6557C15.3342 19.5151 17.0555 18.3738 16.5579 16.8871L14.9887 12.1982L19.0607 9.28449C20.3336 8.37337 19.638 6.43867 18.1229 6.44286L13.0668 6.45588L11.4943 1.75705Z" })), ss = (e) => /* @__PURE__ */ h.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 13 13", ...e }, /* @__PURE__ */ h.createElement("path", { d: "M10.894 1.993l1.398 1.378-7.59 7.698-3.819-3.98L2.299 5.73l2.422 2.522z" })), ts = (e) => /* @__PURE__ */ h.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 17", ...e }, /* @__PURE__ */ h.createElement("path", { d: "M8 4.5c2.2 0 4 1.8 4 4s-1.8 4-4 4-4-1.8-4-4 1.8-4 4-4zm0-3.1c-.3 0-.6.3-.6.6v1c0 .3.3.6.6.6s.6-.3.6-.6V2c0-.3-.3-.6-.6-.6zm0 12c-.3 0-.6.3-.6.6v1c0 .3.3.6.6.6s.6-.3.6-.6v-1c0-.3-.3-.6-.6-.6zm7.1-4.9c0-.3-.3-.6-.6-.6h-1c-.3 0-.6.3-.6.6s.3.6.6.6h1c.3 0 .6-.3.6-.6zm-12 0c0-.3-.3-.6-.6-.6h-1c-.3 0-.6.3-.6.6s.3.6.6.6h1c.3 0 .6-.3.6-.6zm9.9 5c.2-.2.2-.6 0-.8l-.7-.7c-.2-.2-.6-.2-.8 0s-.2.6 0 .8l.7.7c.2.3.6.3.8 0zM4.5 5c.2-.2.2-.6 0-.8l-.7-.7c-.2-.3-.6-.3-.8 0-.3.2-.3.6 0 .8l.7.7c.2.3.6.3.8 0zM13 3.5c-.2-.2-.6-.2-.8 0l-.7.7c-.2.2-.2.6 0 .8.2.2.6.2.8 0l.7-.7c.3-.2.3-.6 0-.8zM4.5 12c-.2-.2-.6-.2-.8 0l-.7.7c-.2.2-.2.6 0 .8.2.2.6.2.8 0l.7-.7c.3-.2.3-.6 0-.8z" })), ns = (e) => /* @__PURE__ */ h.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 17", ...e }, /* @__PURE__ */ h.createElement("path", { d: "M13.5 11.1c.1-.2-.2-.3-.3-.2-1 .9-2.2 1.5-3.7 1.5-3-.1-5.3-2.4-5.3-5.4 0-1.4.6-2.7 1.5-3.7.1-.2 0-.4-.2-.3-2.4.9-4 3.2-4 5.8 0 3.4 2.8 6.2 6.2 6.2 2.6 0 4.9-1.6 5.8-3.9zm-2-5.9c.1-.2.4-.2.5 0l.5 1.1c0 .1.1.1.2.2l1.1.5c.3.1.3.5 0 .6l-1.2.4c-.1 0-.1.1-.2.2L12 9.3c-.1.3-.5.3-.6 0L11 8.1l-.1-.1-1.2-.5c-.2-.1-.2-.4 0-.5l1.1-.5c.1 0 .1-.1.2-.2l.5-1.1zM9.1 2.5c.1-.2.3-.2.4 0l.2.7c0 .1.1.1.1.1l.7.2c.2.1.2.3 0 .4l-.7.3c-.1 0-.1.1-.1.1l-.3.7c0 .1-.3.1-.3 0l-.3-.7c0-.1-.1-.1-.1-.1L8 3.9c-.1 0-.1-.3 0-.3l.7-.2c.1 0 .1-.1.1-.1l.3-.8z" })), as = (e) => /* @__PURE__ */ h.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 6 10", ...e }, /* @__PURE__ */ h.createElement("path", { d: "m0 5.6 3.3-5.6c0-.2.3 0 .3.1v3.9h2.2c.1 0 .2.2.1.3l-3.4 5.5c0 .2-.3 0-.3-.1v-3.9h-2c-.1 0-.2-.2-.2-.3z" })), rs = "본 게시물은 정보통신망 이용촉진 및 정보보호 등에 관한 법률 제 44조 2항을 준수하기 위해 다른 이용자의 요청으로 임시 게시중단 되었습니다.", is = "본 게시물은 정보통신망 이용촉진 및 정보보호 등에 관한 법률 제 44조 2항을 준수하기 위해 다른 이용자의 요청으로 삭제되었습니다.", cs = "임시 게시중단된 리뷰입니다.", ls = "게시중단된 리뷰입니다.", os = (e, t = !1) => t ? e ? cs : ls : e ? rs : is, ds = /* @__PURE__ */ A(
  ({ status: e, detailUrl: t, extra: a, isShortVersion: n, children: r, className: i, clickCode: l, style: c }, d) => {
    const o = e === "TEMPORARILY_SUSPENDED";
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        ref: d,
        className: u(U.block_notice_area, i),
        [x]: l,
        style: c,
        children: [
          /* @__PURE__ */ s.jsxs("div", { className: U.inner, children: [
            /* @__PURE__ */ s.jsx(qe, { className: U.icon_notice, "aria-hidden": "true" }),
            r ?? os(o, n),
            t ? /* @__PURE__ */ s.jsx(b, { href: t, className: U.link, children: "자세히" }) : null
          ] }),
          a ? /* @__PURE__ */ s.jsx("div", { className: U.extra, children: a }) : null
        ]
      }
    );
  }
), ae = ds;
function Nt({ children: e }) {
  return /* @__PURE__ */ s.jsx("div", { className: ze.accessor_btn_area, children: e });
}
const ms = "data:image/png;base64,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", hs = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAACNklEQVR42t2US24UMRCGv7a7pyeQhEAgRETipUCE2IQFK04BN+EmHIE1R2DPFliAxDKzShCzGFBI0i8b61eJ0aDxiB0Sbtnlsav++usx5p+PIn/1cW/6vt8cxnHSHT6f5bTKPw/ejO6XF/5Hsea6B+1OeL2xefai22b2FwxePb39ttm64CY1gYIxEJMMNHhikt+F0x41T17+BnRzgLNnzdY5l9lhg02uUMpsIFCZ4jU6WuJdDrMhPKLgG3VaI728BqL2A236DphykpgsBfAEoBPNYOSjboa0d9qvJ4Ail0Snqz1uEcwggrjIRNIzyQMEIxzEZZBioS/iLN9Bsl8KYER7jtPa0jFSAvcpcQzGQbyyDOSt5h6ibasTK49MtStzDFCM8BMvIyeyBSWBYMGs41d1YpRZI5JBAB1zlYqQAEIeoJKPwPU0lTSjPGAVsiz4HEBnlfhKkFEpwE5AAadQ7qxigFJWcwNvHLwYyVy+B6lnq1BLobZG9iATZ40UbVaqw/IQRLNjkuZAZE3xN9aPAz6dHOhXpoy9inWJxwsklUxbg6TP5yBI5Zz5UEOZDDh7KfJJFOUJyoHmBc5KOZLpPi6fxFNhVzyULBZCmMt+FYPKWsaxOKb0Oq+4CnmAlgpnxosvgVNTOdEvV3ci5mHRz7agNCFbRjXQJz5b9wdK68JChtFS21HlABoCU2b2h2mxfGuNqlCgZjetp8sBxu8+fBnvjujlS1Fb1QPenrnICbPj8oj/afwCyD7u92YbktwAAAAASUVORK5CYII=", us = /* @__PURE__ */ A(
  ({ menus: e, totalPrice: t, className: a, clickCode: n, style: r, localeText: i }, l) => {
    const [c, ...d] = e, o = c == null ? void 0 : c.name, m = d.length;
    return !o && !t ? null : /* @__PURE__ */ s.jsxs(
      "div",
      {
        ref: l,
        className: u(K.payment_summary, a),
        [x]: n,
        style: r,
        children: [
          /* @__PURE__ */ s.jsx("img", { className: K.icon, src: hs, width: "16", height: "16", alt: "이용내역" }),
          o ? /* @__PURE__ */ s.jsxs("span", { className: K.item, children: [
            /* @__PURE__ */ s.jsx("em", { children: o }),
            m > 0 ? ` ${(i == null ? void 0 : i.etc) ?? "외"} ${m}` : null
          ] }) : null,
          t ? /* @__PURE__ */ s.jsx("span", { className: u(K.item, K.type_price), children: t }) : null
        ]
      }
    );
  }
), xt = us, ps = /* @__PURE__ */ A(
  ({
    type: e = "card",
    place: t,
    isBookmarked: a = !1,
    onBookmarkClick: n,
    extra: r,
    className: i,
    bookmarkClickCode: l = "placebookmark",
    style: c,
    localeText: d,
    showBookmark: o = !0,
    anchorProps: m
  }, f) => {
    const { name: v, address: p, category: N } = t, g = t.isAvailable ?? !!(p || N), j = !!(m != null && m.href || m != null && m.onClick), y = j ? b : "span";
    return /* @__PURE__ */ s.jsx(
      "div",
      {
        className: u(S.place_info_area, i, {
          [S.type_card]: e == "card",
          [S.type_removed]: !g
        }),
        ref: f,
        style: c,
        children: /* @__PURE__ */ s.jsxs("div", { className: S.inner, children: [
          /* @__PURE__ */ s.jsxs(y, { className: S.info_area, ...m, children: [
            /* @__PURE__ */ s.jsxs("div", { className: S.tit_area, children: [
              /* @__PURE__ */ s.jsx("span", { className: S.name, children: v }),
              g && j && /* @__PURE__ */ s.jsx(We, { className: S.icon, "aria-hidden": "true" })
            ] }),
            g ? /* @__PURE__ */ s.jsxs("div", { className: S.txt_area, children: [
              N && /* @__PURE__ */ s.jsx("span", { className: S.item, children: N }),
              p && /* @__PURE__ */ s.jsx("span", { className: S.item, children: p })
            ] }) : /* @__PURE__ */ s.jsxs("div", { className: u(S.txt_area), children: [
              /* @__PURE__ */ s.jsx(Ze, { className: S.icon, "aria-hidden": "true" }),
              (d == null ? void 0 : d.unavailablePlace) ?? "폐업했거나 정보 제공이 중지된 장소입니다."
            ] })
          ] }),
          o && g && /* @__PURE__ */ s.jsx("div", { className: S.bookmark_btn_wrapper, children: /* @__PURE__ */ s.jsxs(
            b,
            {
              onClick: n,
              "aria-pressed": a,
              className: S.btn_bookmark,
              [x]: l,
              children: [
                a ? /* @__PURE__ */ s.jsx(es, { className: S.icon, "aria-hidden": "true" }) : /* @__PURE__ */ s.jsx($e, { className: S.icon, "aria-hidden": "true" }),
                /* @__PURE__ */ s.jsx("span", { className: "pui__blind", children: (d == null ? void 0 : d.bookmarkForA11y) ?? "저장" })
              ]
            }
          ) }),
          r
        ] })
      }
    );
  }
), yt = ps, fs = /* @__PURE__ */ A(
  ({ names: e, className: t, clickCode: a, style: n }, r) => /* @__PURE__ */ s.jsx(
    "div",
    {
      ref: r,
      className: u(ue.product_area, t),
      [x]: a,
      style: n,
      children: e.map((i, l) => /* @__PURE__ */ s.jsx("span", { className: ue.item, children: i }, l))
    }
  )
), bt = fs, vs = /* @__PURE__ */ A(
  ({
    Element: e,
    isSmallSize: t,
    isMyType: a,
    isFollowing: n,
    localeText: r,
    reactionEmojiUrl: i,
    profileImageUrl: l,
    borderImageUrl: c,
    profileImageSize: d,
    href: o,
    onClick: m,
    target: f,
    clickCode: v
  }, p) => /* @__PURE__ */ s.jsxs(
    e,
    {
      ref: p,
      className: u(z.author_thumb_area, {
        [z.type_small]: t,
        [z.type_following]: n
      }),
      [x]: v,
      href: o,
      onClick: m,
      target: f,
      children: [
        /* @__PURE__ */ s.jsxs("div", { className: "pui__thumb", style: { width: d + 4, height: d + 4 }, children: [
          /* @__PURE__ */ s.jsx(
            "img",
            {
              className: z.img,
              src: l ?? ms,
              width: d,
              height: d,
              alt: "프로필"
            }
          ),
          c && /* @__PURE__ */ s.jsx("div", { className: z.profile_border, children: /* @__PURE__ */ s.jsx("img", { src: c, width: "100%", height: "100%", alt: "프로필 띠" }) })
        ] }),
        !a && n && /* @__PURE__ */ s.jsxs("span", { className: u(z.label, z.type_following), children: [
          /* @__PURE__ */ s.jsx(ss, { className: z.icon, "aria-hidden": "true" }),
          /* @__PURE__ */ s.jsx("span", { className: "pui__blind", children: (r == null ? void 0 : r.followingForA11y) ?? "팔로잉한 리뷰어" })
        ] }),
        i && /* @__PURE__ */ s.jsx("span", { className: u(z.label, z.type_reaction), children: /* @__PURE__ */ s.jsx("img", { className: z.emoji, src: i, width: "18", height: "18", alt: "" }) })
      ]
    }
  )
), gs = vs, js = /* @__PURE__ */ A(
  ({
    author: e,
    relationship: t = "NO_RELATIONSHIP",
    showStat: a = !0,
    showRelationLabel: n = !0,
    reactionEmojiUrl: r,
    className: i,
    style: l,
    extra: c,
    clickCode: d = "profile",
    localeText: o,
    href: m,
    onClick: f,
    target: v,
    size: p = "medium"
  }, N) => {
    const g = t === "ME", j = t === "FOLLOWING", y = p === "small", L = y ? 28 : 38, { nickname: M, statTexts: O, borderImageUrl: C, profileImageUrl: G } = e, V = m || f ? b : "span";
    return /* @__PURE__ */ s.jsxs("div", { className: u(k.author_area, i), style: l, ref: N, children: [
      /* @__PURE__ */ s.jsx(
        gs,
        {
          Element: V,
          isSmallSize: y,
          isMyType: g,
          isFollowing: j,
          localeText: o,
          reactionEmojiUrl: r,
          profileImageSize: L,
          profileImageUrl: G,
          borderImageUrl: C,
          href: m,
          onClick: f,
          target: v,
          clickCode: d
        }
      ),
      /* @__PURE__ */ s.jsxs(
        V,
        {
          className: u(k.author_info_area, { [k.type_small]: y }),
          [x]: d,
          href: m,
          onClick: f,
          target: v,
          children: [
            /* @__PURE__ */ s.jsxs("div", { className: k.name_area, children: [
              /* @__PURE__ */ s.jsx("span", { className: k.name, children: /* @__PURE__ */ s.jsx("span", { className: k.txt, children: M }) }),
              n && j && /* @__PURE__ */ s.jsx("span", { className: k.label, children: /* @__PURE__ */ s.jsx("em", { children: (o == null ? void 0 : o.following) ?? "내가 팔로잉한" }) }),
              n && g && /* @__PURE__ */ s.jsx("span", { className: k.label, children: /* @__PURE__ */ s.jsx("em", { children: (o == null ? void 0 : o.myReview) ?? "내 리뷰" }) })
            ] }),
            a && (Array.isArray(O) ? /* @__PURE__ */ s.jsx("div", { className: k.count_area, children: O == null ? void 0 : O.map((Q, se) => /* @__PURE__ */ s.jsx("span", { className: k.item, children: Q }, se)) }) : O)
          ]
        }
      ),
      c
    ] });
  }
), At = js, ws = /* @__PURE__ */ A(({ rating: e, className: t, clickCode: a, style: n, localeText: r }, i) => /* @__PURE__ */ s.jsxs(
  "div",
  {
    className: u(pe.rating, t),
    ref: i,
    [x]: a,
    style: n,
    children: [
      /* @__PURE__ */ s.jsx("span", { className: "pui__blind", children: (r == null ? void 0 : r.ratingForA11y) ?? "별점" }),
      /* @__PURE__ */ s.jsx(Je, { className: pe.icon, "aria-hidden": "true" }),
      e,
      /* @__PURE__ */ s.jsx("span", { className: "pui__blind", children: (r == null ? void 0 : r.unitForA11y) ?? "점" })
    ]
  }
)), Ct = ws, Ns = ({ text: e }) => {
  if (typeof e != "string")
    return e;
  const t = e.split(`
`);
  return /* @__PURE__ */ s.jsx(ie.Fragment, { children: t.map((a, n) => /* @__PURE__ */ s.jsxs(ie.Fragment, { children: [
    a,
    n < t.length - 1 && /* @__PURE__ */ s.jsx("br", {})
  ] }, n)) });
}, xs = Ns, ys = ({
  text: e,
  highlightRanges: t,
  style: a = { fontWeight: "700" }
}) => {
  if (t.length === 0)
    return [e];
  const n = t.slice().sort((l, c) => l.start - c.start), r = [];
  let i = 0;
  return n.forEach((l, c) => {
    const { start: d, end: o } = l;
    i < d && r.push(e.substring(i, d)), r.push(
      /* @__PURE__ */ s.jsx("mark", { style: a, children: e.substring(d, o) }, `highlight-${c}`)
    ), i = o;
  }), i < e.length && r.push(e.substring(i)), r;
}, bs = (e) => {
  const [t, a] = J(!1);
  return Ne(() => {
    const n = e.current;
    if (n) {
      const r = n.scrollHeight > n.clientHeight;
      a(r);
    }
  }, []), t;
}, As = (e, t) => t ? {
  display: "-webkit-box",
  overflow: "hidden",
  textOverflow: "ellipsis",
  WebkitBoxOrient: "vertical",
  wordBreak: "break-all",
  lineClamp: e,
  WebkitLineClamp: e
} : {
  display: "inherit"
}, ve = "2.2rem", Cs = /* @__PURE__ */ A(
  ({
    text: e,
    onClickText: t,
    style: a = {},
    displayLines: n = 3,
    className: r,
    clickCode: i,
    foldClickCode: l = "text",
    unfoldClickCode: c = "text",
    isFolded: d,
    highlightRanges: o = [],
    highlightStyle: m,
    foldable: f = !0,
    showToggleButton: v = !0,
    onToggleButtonClick: p,
    mergeLines: N = !1,
    localeText: g
  }, j) => {
    const y = xe(null), L = j ?? y, [M, O] = J(!0), C = d ?? M, G = bs(L), V = f && G, Q = () => {
      V && O(!C);
    }, se = (I) => {
      t == null || t(I, C), Q();
    }, Oe = (I) => {
      p == null || p(I, C), Q();
    }, _e = !t && !V ? "span" : b, De = Ve(() => {
      const I = ys({ highlightRanges: o, text: e, style: m });
      return N ? I.map((W) => typeof W == "string" ? W.replaceAll(`
`, " ") : W) : I.map((W, Le) => /* @__PURE__ */ s.jsx(xs, { text: W }, Le));
    }, [o, e, m, f]), he = i ?? (C ? c : l);
    return /* @__PURE__ */ s.jsxs(ye, { children: [
      /* @__PURE__ */ s.jsx(
        _e,
        {
          ref: L,
          className: r,
          onClick: se,
          style: {
            lineHeight: ve,
            wordBreak: "break-all",
            ...As(n, C),
            ...a
          },
          [x]: he,
          children: De
        }
      ),
      v && V ? /* @__PURE__ */ s.jsx(
        b,
        {
          className: ke.btn,
          onClick: Oe,
          "aria-expanded": !C,
          style: {
            lineHeight: a.lineHeight ?? ve
          },
          [x]: he,
          children: C ? (g == null ? void 0 : g.showMore) ?? "더보기" : (g == null ? void 0 : g.showLess) ?? "접기"
        }
      ) : null
    ] });
  }
), T = Cs, Ss = ({
  status: e,
  foldableEllipsisProps: t,
  text: a,
  localeUrl: n
}) => {
  switch (e) {
    case "ACTIVE":
      return /* @__PURE__ */ s.jsx(T, { ...t, text: a });
    case "PERMANENTLY_SUSPENDED":
    case "TEMPORARILY_SUSPENDED":
      return /* @__PURE__ */ s.jsx(ae, { status: e });
    case "HIDDEN":
      return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        /* @__PURE__ */ s.jsx(T, { ...t, text: a }),
        /* @__PURE__ */ s.jsx(ae, { className: fe.blocked_info, detailUrl: n == null ? void 0 : n.hiddenReply, children: "이용정책에 의해 숨김처리 되었습니다." })
      ] });
    case "OUTDATED":
      return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        /* @__PURE__ */ s.jsx(T, { ...t, text: a }),
        /* @__PURE__ */ s.jsx(ae, { className: fe.blocked_info, detailUrl: n == null ? void 0 : n.outdatedReply, children: "답글을 등록한 이후에 리뷰 내용이 수정되었어요." })
      ] });
    default:
      return null;
  }
}, Es = (e) => {
  const { height: t = 50, isPageType: a = !1, isTransparentBg: n = !1 } = e;
  return /* @__PURE__ */ s.jsxs(
    "div",
    {
      className: u(_.load_area_wrapper, {
        [_.is_page]: a,
        [_.is_transparent_bg]: n
      }),
      style: a ? {} : { height: t },
      children: [
        /* @__PURE__ */ s.jsx("span", { className: "pui__blind", children: "로딩중" }),
        /* @__PURE__ */ s.jsxs("div", { className: _.load_area, children: [
          /* @__PURE__ */ s.jsx("div", { className: u(_.dot, _.dot1) }),
          /* @__PURE__ */ s.jsx("div", { className: u(_.dot, _.dot2) }),
          /* @__PURE__ */ s.jsx("div", { className: u(_.dot, _.dot3) }),
          /* @__PURE__ */ s.jsx("div", { className: u(_.dot, _.dot4) }),
          /* @__PURE__ */ s.jsx("div", { className: u(_.dot, _.dot5) }),
          /* @__PURE__ */ s.jsx("div", { className: u(_.dot, _.dot6) })
        ] })
      ]
    }
  );
}, Os = Es, _s = /* @__PURE__ */ A(
  ({ isTranslated: e, onClick: t, className: a, clickCode: n = "translatebutton", style: r, locale: i = "ko", isLoading: l }, c) => /* @__PURE__ */ s.jsx("div", { ref: c, className: u(B.translation_area, a), style: r, children: e ? /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx(b, { className: B.item, onClick: t, [x]: n, children: D.showOriginal[i] }),
    /* @__PURE__ */ s.jsxs("span", { className: u(B.item, B.type_by), children: [
      D.translatedByPapago[i],
      " Papago"
    ] })
  ] }) : /* @__PURE__ */ s.jsxs(b, { className: B.btn_translation, onClick: t, [x]: n, children: [
    /* @__PURE__ */ s.jsx(Te, { className: B.icon_papago, "aria-hidden": "true" }),
    D.showTranslated[i],
    l ? /* @__PURE__ */ s.jsx("span", { className: B.loading_area, children: /* @__PURE__ */ s.jsx(Os, { height: 10 }) }) : null
  ] }) })
), Ds = _s, Ls = ["PERMANENTLY_SUSPENDED", "TEMPORARILY_SUSPENDED"], Ms = /* @__PURE__ */ A(
  ({
    text: e,
    replierName: t,
    date: a,
    dateForA11y: n,
    status: r = "ACTIVE",
    isOwnerView: i = !1,
    onEditClick: l,
    onDeleteClick: c,
    className: d,
    editClickCode: o = "replyedit",
    deleteClickCode: m = "replydelete",
    style: f,
    localeText: v,
    localeUrl: p,
    editable: N = !0,
    foldableEllipsisProps: g,
    afterReplyArea: j,
    translationButtonProps: y
  }, L) => {
    const M = Ls.includes(r);
    return /* @__PURE__ */ s.jsxs("div", { className: u(P.reply, d), style: f, ref: L, children: [
      /* @__PURE__ */ s.jsx(Ie, { className: P.icon, "aria-hidden": "true" }),
      /* @__PURE__ */ s.jsxs("div", { className: P.info, children: [
        /* @__PURE__ */ s.jsx("span", { className: P.replyer, children: t }),
        !M && /* @__PURE__ */ s.jsxs("span", { className: P.date, children: [
          /* @__PURE__ */ s.jsx("time", { "aria-hidden": "true", children: a }),
          n && /* @__PURE__ */ s.jsx("span", { className: "pui__blind", children: n })
        ] })
      ] }),
      /* @__PURE__ */ s.jsx("div", { className: P.txt, children: /* @__PURE__ */ s.jsx(Ss, { text: e, foldableEllipsisProps: g, localeUrl: p, status: r }) }),
      i && /* @__PURE__ */ s.jsx(s.Fragment, { children: /* @__PURE__ */ s.jsxs("div", { className: P.btn_area, children: [
        /* @__PURE__ */ s.jsx(
          b,
          {
            onClick: l,
            className: P.btn,
            "aria-disabled": !N,
            [x]: o,
            children: (v == null ? void 0 : v.edit) ?? "수정"
          }
        ),
        /* @__PURE__ */ s.jsx(
          b,
          {
            onClick: c,
            className: P.btn,
            [x]: m,
            children: (v == null ? void 0 : v.delete) ?? "삭제"
          }
        )
      ] }) }),
      y && /* @__PURE__ */ s.jsx("div", { className: P.translation_btn_area, children: /* @__PURE__ */ s.jsx(Ds, { ...y }) }),
      j
    ] });
  }
), St = Ms, zs = /* @__PURE__ */ A(({ text: e, foldableEllipsisProps: t, className: a, style: n }, r) => /* @__PURE__ */ s.jsx("div", { ref: r, className: u(Pe.txt_area, a), style: n, children: /* @__PURE__ */ s.jsx(
  T,
  {
    ...t,
    text: e,
    foldable: (t == null ? void 0 : t.foldable) ?? !!t
  }
) })), Et = zs, ks = /* @__PURE__ */ A(({ children: e, className: t, clickCode: a, style: n }, r) => /* @__PURE__ */ s.jsx(
  "div",
  {
    ref: r,
    className: u(Re.tit_area, t),
    [x]: a,
    style: n,
    children: e
  }
)), Ot = ks, Z = ({
  title: e,
  text: t,
  link: a,
  children: n
}) => {
  const { clickCode: r, text: i, className: l, ...c } = a ?? {};
  return /* @__PURE__ */ s.jsxs("div", { className: R.info_item, children: [
    e && /* @__PURE__ */ s.jsx("span", { className: R.tit, children: e }),
    t || a ? /* @__PURE__ */ s.jsxs("span", { className: R.item, children: [
      t,
      a && /* @__PURE__ */ s.jsxs(
        b,
        {
          className: u(R.link, l),
          [x]: r,
          ...c,
          children: [
            i,
            /* @__PURE__ */ s.jsx(Ge, { className: R.icon, "aria-hidden": "true" })
          ]
        }
      )
    ] }) : null,
    n
  ] });
}, Ps = /* @__PURE__ */ A(
  ({
    proofNames: e,
    visitDate: t,
    visitDateForA11y: a,
    createDate: n,
    createDateForA11y: r,
    additionalInfos: i = [],
    bookingUser: l,
    className: c,
    style: d,
    localeText: o,
    paymentLink: m
  }, f) => /* @__PURE__ */ s.jsxs("div", { ref: f, className: u(R.smartplace_visit_info_area, c), style: d, children: [
    /* @__PURE__ */ s.jsxs(Z, { title: (o == null ? void 0 : o.visitDate) ?? "방문일", children: [
      /* @__PURE__ */ s.jsxs("span", { className: R.item, children: [
        /* @__PURE__ */ s.jsx("time", { "aria-hidden": "true", children: t }),
        /* @__PURE__ */ s.jsx("span", { className: "pui__blind", children: a })
      ] }),
      e == null ? void 0 : e.map((v, p) => /* @__PURE__ */ s.jsx("span", { className: u(R.item, { [R.type_main]: p === 0 }), children: v }, p))
    ] }),
    l && /* @__PURE__ */ s.jsx(
      Z,
      {
        title: (o == null ? void 0 : o.bookingUser) ?? "예약자",
        text: `${l.name} `,
        link: l.link
      }
    ),
    /* @__PURE__ */ s.jsx(Z, { title: (o == null ? void 0 : o.createDate) ?? "작성일", children: /* @__PURE__ */ s.jsxs("span", { className: R.item, children: [
      /* @__PURE__ */ s.jsx("time", { "aria-hidden": "true", children: n }),
      /* @__PURE__ */ s.jsx("span", { className: "pui__blind", children: r })
    ] }) }),
    i.map(({ label: v, value: p }) => /* @__PURE__ */ s.jsx(Z, { title: v, text: p }, v)),
    m && /* @__PURE__ */ s.jsx(
      Z,
      {
        link: {
          ...m,
          clickCode: m.clickCode ?? "paymentdetail",
          text: (o == null ? void 0 : o.showProofDetail) ?? "결제 정보 상세 보기"
        }
      }
    )
  ] })
), _t = Ps;
var ce = /* @__PURE__ */ ((e) => (e.Morning = "Morning", e.Afternoon = "Afternoon", e.Evening = "Evening", e.Night = "Night", e))(ce || {});
function Rs(e) {
  const t = new Date(e), a = 9 * 60, n = new Date(t.getTime() + a * 60 * 1e3), r = n.getUTCHours(), i = n.getUTCMinutes();
  return r >= 5 && r < 10 || r === 10 && i < 30 ? "Morning" : r >= 10 && r < 17 ? "Afternoon" : r >= 17 && r < 23 ? "Evening" : "Night";
}
const Hs = ({ timeOfDay: e }) => e === ce.Morning || e === ce.Afternoon ? /* @__PURE__ */ s.jsx(ts, { className: F.icon, "aria-hidden": "true" }) : /* @__PURE__ */ s.jsx(ns, { className: F.icon, "aria-hidden": "true" }), Vs = ({ visitDateTime: e }) => {
  const t = Rs(e), { t: a } = Y();
  return /* @__PURE__ */ s.jsxs("span", { className: u(F.item, F.time, F[t.toLowerCase()]), children: [
    /* @__PURE__ */ s.jsx(Hs, { timeOfDay: t }),
    /* @__PURE__ */ s.jsx("em", { children: a(D[`visit${t}`]) })
  ] });
}, Bs = /* @__PURE__ */ A(
  ({
    visitDateTime: e,
    visitCategories: t,
    initialExpand: a = !1,
    onExpandClick: n,
    className: r,
    clickCode: i = "visitkeywords",
    style: l,
    isFolded: c
  }, d) => {
    const [o, m] = J(!a), f = !a && c !== void 0 ? c : o, v = (p) => {
      n == null || n(p), m(!o);
    };
    return /* @__PURE__ */ s.jsxs(
      b,
      {
        ref: d,
        className: u(F.btn, r),
        "aria-haspopup": "true",
        "aria-expanded": !f,
        onClick: v,
        [x]: i,
        style: l,
        children: [
          e ? /* @__PURE__ */ s.jsx(Vs, { visitDateTime: e }) : null,
          t.map(({ code: p, name: N, keywords: g }) => /* @__PURE__ */ s.jsxs("span", { className: F.item, children: [
            N && `${N} `,
            /* @__PURE__ */ s.jsx("em", { children: g.map((j) => j.name).join(", ") })
          ] }, p))
        ]
      }
    );
  }
), Dt = Bs, Fs = /* @__PURE__ */ A(
  ({
    keywords: e = [],
    visibleKeywordCount: t = 1,
    initialExpand: a = !1,
    onExpandClick: n,
    className: r,
    expandClickCode: i = "votedkeywordsmore",
    style: l,
    localeText: c,
    isFolded: d,
    onClick: o,
    clickCode: m
  }, f) => {
    const [v, p] = J(!a), N = !a && d !== void 0 ? d : v, g = e.slice(0, t), j = e.length - g.length, y = N ? g : e, L = (C) => {
      n == null || n(C), p(!v);
    }, M = o ? b : "div", O = o ? "span" : b;
    return /* @__PURE__ */ s.jsxs(
      M,
      {
        className: u(q.keyword_area, r),
        style: l,
        ref: f,
        onClick: o,
        [x]: m,
        children: [
          y.map(({ code: C, iconUrl: G, name: V }) => /* @__PURE__ */ s.jsxs("span", { className: q.item, children: [
            /* @__PURE__ */ s.jsx("img", { className: q.icon, src: G, width: "18", height: "18", alt: "" }),
            V
          ] }, C)),
          N && j > 0 && /* @__PURE__ */ s.jsxs(
            O,
            {
              className: u(q.item, q.btn_more),
              "aria-haspopup": "true",
              "aria-expanded": !N,
              onClick: o ? void 0 : L,
              [x]: i,
              children: [
                "+",
                j,
                /* @__PURE__ */ s.jsx("span", { className: "pui__blind", children: (c == null ? void 0 : c.moreReviewForA11y) ?? "개의 리뷰가 더 있습니다" }),
                /* @__PURE__ */ s.jsx("span", { className: "pui__blind", children: (c == null ? void 0 : c.expandForA11y) ?? "펼쳐보기" })
              ]
            }
          )
        ]
      }
    );
  }
), Lt = Fs;
function Is({ show: e, handleMousedownOutside: t, children: a }) {
  const n = xe(null);
  return Ne(() => {
    const r = (i) => {
      const l = n.current;
      l && i.target instanceof Node && (l != null && l.contains(i.target)) || t(i);
    };
    return window.addEventListener("mousedown", r), () => {
      window.removeEventListener("mousedown", r);
    };
  }, [e, t]), e ? /* @__PURE__ */ s.jsx("div", { ref: n, children: a }) : null;
}
var ee = {}, Ys = function() {
  var e = document.getSelection();
  if (!e.rangeCount)
    return function() {
    };
  for (var t = document.activeElement, a = [], n = 0; n < e.rangeCount; n++)
    a.push(e.getRangeAt(n));
  switch (t.tagName.toUpperCase()) {
    case "INPUT":
    case "TEXTAREA":
      t.blur();
      break;
    default:
      t = null;
      break;
  }
  return e.removeAllRanges(), function() {
    e.type === "Caret" && e.removeAllRanges(), e.rangeCount || a.forEach(function(r) {
      e.addRange(r);
    }), t && t.focus();
  };
}, Gs = Ys, ge = {
  "text/plain": "Text",
  "text/html": "Url",
  default: "Text"
}, Ws = "Copy to clipboard: #{key}, Enter";
function Us(e) {
  var t = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return e.replace(/#{\s*key\s*}/g, t);
}
function Ks(e, t) {
  var a, n, r, i, l, c, d = !1;
  t || (t = {}), a = t.debug || !1;
  try {
    r = Gs(), i = document.createRange(), l = document.getSelection(), c = document.createElement("span"), c.textContent = e, c.ariaHidden = "true", c.style.all = "unset", c.style.position = "fixed", c.style.top = 0, c.style.clip = "rect(0, 0, 0, 0)", c.style.whiteSpace = "pre", c.style.webkitUserSelect = "text", c.style.MozUserSelect = "text", c.style.msUserSelect = "text", c.style.userSelect = "text", c.addEventListener("copy", function(m) {
      if (m.stopPropagation(), t.format)
        if (m.preventDefault(), typeof m.clipboardData > "u") {
          a && console.warn("unable to use e.clipboardData"), a && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
          var f = ge[t.format] || ge.default;
          window.clipboardData.setData(f, e);
        } else
          m.clipboardData.clearData(), m.clipboardData.setData(t.format, e);
      t.onCopy && (m.preventDefault(), t.onCopy(m.clipboardData));
    }), document.body.appendChild(c), i.selectNodeContents(c), l.addRange(i);
    var o = document.execCommand("copy");
    if (!o)
      throw new Error("copy command was unsuccessful");
    d = !0;
  } catch (m) {
    a && console.error("unable to copy using execCommand: ", m), a && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(t.format || "text", e), t.onCopy && t.onCopy(window.clipboardData), d = !0;
    } catch (f) {
      a && console.error("unable to copy using clipboardData: ", f), a && console.error("falling back to prompt"), n = Us("message" in t ? t.message : Ws), window.prompt(n, e);
    }
  } finally {
    l && (typeof l.removeRange == "function" ? l.removeRange(i) : l.removeAllRanges()), c && document.body.removeChild(c), r();
  }
  return d;
}
var qs = Ks;
function le(e) {
  "@babel/helpers - typeof";
  return le = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, le(e);
}
Object.defineProperty(ee, "__esModule", {
  value: !0
});
ee.CopyToClipboard = void 0;
var X = Ce(ie), Zs = Ce(qs), Js = ["text", "onCopy", "options", "children"];
function Ce(e) {
  return e && e.__esModule ? e : { default: e };
}
function je(e, t) {
  var a = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), a.push.apply(a, n);
  }
  return a;
}
function we(e) {
  for (var t = 1; t < arguments.length; t++) {
    var a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? je(Object(a), !0).forEach(function(n) {
      me(e, n, a[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : je(Object(a)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(a, n));
    });
  }
  return e;
}
function Qs(e, t) {
  if (e == null)
    return {};
  var a = Xs(e, t), n, r;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (a[n] = e[n]);
  }
  return a;
}
function Xs(e, t) {
  if (e == null)
    return {};
  var a = {}, n = Object.keys(e), r, i;
  for (i = 0; i < n.length; i++)
    r = n[i], !(t.indexOf(r) >= 0) && (a[r] = e[r]);
  return a;
}
function Ts(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function $s(e, t) {
  for (var a = 0; a < t.length; a++) {
    var n = t[a];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function et(e, t, a) {
  return t && $s(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function st(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && oe(e, t);
}
function oe(e, t) {
  return oe = Object.setPrototypeOf || function(n, r) {
    return n.__proto__ = r, n;
  }, oe(e, t);
}
function tt(e) {
  var t = at();
  return function() {
    var n = $(e), r;
    if (t) {
      var i = $(this).constructor;
      r = Reflect.construct(n, arguments, i);
    } else
      r = n.apply(this, arguments);
    return nt(this, r);
  };
}
function nt(e, t) {
  if (t && (le(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Se(e);
}
function Se(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function at() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function $(e) {
  return $ = Object.setPrototypeOf ? Object.getPrototypeOf : function(a) {
    return a.__proto__ || Object.getPrototypeOf(a);
  }, $(e);
}
function me(e, t, a) {
  return t in e ? Object.defineProperty(e, t, { value: a, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = a, e;
}
var Ee = /* @__PURE__ */ function(e) {
  st(a, e);
  var t = tt(a);
  function a() {
    var n;
    Ts(this, a);
    for (var r = arguments.length, i = new Array(r), l = 0; l < r; l++)
      i[l] = arguments[l];
    return n = t.call.apply(t, [this].concat(i)), me(Se(n), "onClick", function(c) {
      var d = n.props, o = d.text, m = d.onCopy, f = d.children, v = d.options, p = X.default.Children.only(f), N = (0, Zs.default)(o, v);
      m && m(o, N), p && p.props && typeof p.props.onClick == "function" && p.props.onClick(c);
    }), n;
  }
  return et(a, [{
    key: "render",
    value: function() {
      var r = this.props;
      r.text, r.onCopy, r.options;
      var i = r.children, l = Qs(r, Js), c = X.default.Children.only(i);
      return /* @__PURE__ */ X.default.cloneElement(c, we(we({}, l), {}, {
        onClick: this.onClick
      }));
    }
  }]), a;
}(X.default.PureComponent);
ee.CopyToClipboard = Ee;
me(Ee, "defaultProps", {
  onCopy: void 0,
  options: void 0
});
var rt = ee, de = rt.CopyToClipboard;
de.CopyToClipboard = de;
var it = de;
const ct = /* @__PURE__ */ be(it);
function re({ copyText: e, copyName: t, onClick: a, onCopyFail: n, clickCode: r }) {
  const { t: i } = Y(), l = async (d) => {
    try {
      await navigator.clipboard.writeText(d);
    } catch (o) {
      n == null || n(o);
    }
  }, c = () => {
    a && t && a(t), l(e);
  };
  return /* @__PURE__ */ s.jsx(ct, { text: e, children: /* @__PURE__ */ s.jsx(
    b,
    {
      className: u(He.btn, "pui__bluelink"),
      onClick: c,
      title: "복사",
      [x]: r,
      children: i(D.copy)
    }
  ) });
}
function lt({
  distance: e,
  roadAddress: t,
  address: a,
  zipCode: n,
  displayAddress: r,
  isEven: i,
  parkinglotTypeTag: l,
  copyButtonProps: c,
  foldClickCode: d = "address",
  unfoldClickCode: o = "address",
  onLayerPopupOpen: m,
  showMoreAddress: f,
  setShowMoreAddress: v
}) {
  const { t: p } = Y(), [N, g] = J(!1), j = f ?? N, y = v ?? g, L = () => {
    j || m == null || m(), y((C) => !C);
  }, M = Be(() => {
    y(!1);
  }, []), { onClick: O } = c || {};
  return a ? /* @__PURE__ */ s.jsxs("div", { className: u(w.address_area), children: [
    e && /* @__PURE__ */ s.jsxs("span", { className: u(w.item, w.type_distance), children: [
      /* @__PURE__ */ s.jsx("span", { className: "pui__blind", children: "현재 위치에서" }),
      e
    ] }),
    /* @__PURE__ */ s.jsxs("span", { className: w.item, children: [
      l && /* @__PURE__ */ s.jsx("span", { className: w.label_socar, children: l }),
      /* @__PURE__ */ s.jsxs(
        b,
        {
          className: w.address,
          "aria-haspopup": "true",
          "aria-expanded": j,
          onClick: L,
          onMouseDown: (C) => {
            j && C.stopPropagation();
          },
          [x]: j ? d : o,
          children: [
            /* @__PURE__ */ s.jsx("span", { className: w.txt, children: r }),
            /* @__PURE__ */ s.jsxs("span", { className: w.icon_area, children: [
              /* @__PURE__ */ s.jsxs("span", { className: "pui__blind", children: [
                "상세주소",
                `${j ? " 닫기" : " 열기"}`
              ] }),
              /* @__PURE__ */ s.jsx(Ue, { className: w.icon, "aria-hidden": "true" })
            ] })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ s.jsx(Is, { show: j, handleMousedownOutside: M, children: /* @__PURE__ */ s.jsxs(
      "div",
      {
        className: u(w.ly_address, {
          [w.type_even]: i
        }),
        children: [
          t && /* @__PURE__ */ s.jsxs("div", { className: w.item_address, children: [
            /* @__PURE__ */ s.jsx("span", { className: w.label, children: p(D.roadAddress) }),
            t,
            /* @__PURE__ */ s.jsx("span", { className: w.btn_wrapper, children: /* @__PURE__ */ s.jsx(
              re,
              {
                copyName: p(D.roadAddressFull),
                copyText: t,
                ...O && { onClick: O }
              }
            ) })
          ] }),
          a && /* @__PURE__ */ s.jsxs("div", { className: w.item_address, children: [
            /* @__PURE__ */ s.jsx("span", { className: w.label, children: p(D.oldAddress) }),
            a,
            /* @__PURE__ */ s.jsx("span", { className: w.btn_wrapper, children: /* @__PURE__ */ s.jsx(
              re,
              {
                copyName: p(D.oldAddressFull),
                copyText: a,
                ...O && { onClick: O }
              }
            ) })
          ] }),
          n && /* @__PURE__ */ s.jsxs("div", { className: w.item_address, children: [
            /* @__PURE__ */ s.jsx("span", { className: u(w.label, w.type_zipcode), "aria-hidden": "true", children: p(D.zipCode) }),
            /* @__PURE__ */ s.jsx("span", { className: "pui__blind", children: "우편번호" }),
            n,
            /* @__PURE__ */ s.jsx("span", { className: w.btn_wrapper, children: /* @__PURE__ */ s.jsx(
              re,
              {
                copyName: p(D.zipCode),
                copyText: n,
                ...O && { onClick: O }
              }
            ) })
          ] }),
          /* @__PURE__ */ s.jsxs(b, { className: w.btn_close, onClick: () => y(!1), children: [
            /* @__PURE__ */ s.jsx("span", { className: "pui__blind", children: "팝업 닫기" }),
            /* @__PURE__ */ s.jsx(Ke, { className: w.icon, "aria-hidden": "true" })
          ] })
        ]
      }
    ) })
  ] }) : null;
}
function ot() {
  const { locale: e } = Y();
  return /* @__PURE__ */ s.jsx("span", { className: te.icon_wrapper, children: e === "ko" ? /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx(Qe, { className: te.icon, "aria-hidden": "true" }),
    /* @__PURE__ */ s.jsx("span", { className: "pui__blind", children: "예약" })
  ] }) : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx(Xe, { className: te.icon, "aria-hidden": "true" }),
    /* @__PURE__ */ s.jsx("span", { className: "pui__blind", children: "Booking" })
  ] }) });
}
const dt = /* @__PURE__ */ A(
  ({
    name: e,
    category: t,
    carTotalCount: a,
    businessHours: n,
    hasBooking: r = !1,
    index: i = 0,
    isTwoColumn: l = !1,
    anchorProps: c,
    extraTopRight: d,
    addressAreaProps: o,
    style: m,
    className: f,
    variant: v,
    clickCode: p
  }, N) => {
    const {
      status: g,
      description: j,
      dayOff: y,
      dayOffDescription: L
    } = n || {}, M = v === "normal" ? void 0 : E[`type_${v}`];
    return /* @__PURE__ */ s.jsxs("div", { className: u(E.info_area, f, M), style: m, ref: N, children: [
      /* @__PURE__ */ s.jsx(b, { className: E.info_link, ...c, [x]: p, children: /* @__PURE__ */ s.jsx("div", { className: E.tit_area, children: /* @__PURE__ */ s.jsxs("div", { className: u("pui__bluelink", E.tit_inner), children: [
        /* @__PURE__ */ s.jsx("span", { className: E.name, children: e }),
        r && /* @__PURE__ */ s.jsx(ot, {}),
        /* @__PURE__ */ s.jsx("span", { className: E.category, children: t })
      ] }) }) }),
      /* @__PURE__ */ s.jsx("div", { className: E.txt_area, children: /* @__PURE__ */ s.jsxs("div", { className: E.txt_inner, children: [
        g && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
          g && /* @__PURE__ */ s.jsx("span", { className: u(E.item, E.type_status), children: g }),
          j && /* @__PURE__ */ s.jsx("span", { className: E.item, children: j })
        ] }),
        y && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
          y && /* @__PURE__ */ s.jsx("span", { className: u(E.item, E.type_status), children: y }),
          L && /* @__PURE__ */ s.jsx("span", { className: E.item, children: L })
        ] }),
        a > 0 && /* @__PURE__ */ s.jsxs("span", { className: E.item, children: [
          "보유차량 ",
          a,
          "대"
        ] })
      ] }) }),
      /* @__PURE__ */ s.jsx("div", { className: E.txt_area, children: /* @__PURE__ */ s.jsx(lt, { ...o, isEven: !!(l && (i + 1) % 2 === 0) }) }),
      d
    ] });
  }
), Mt = dt, mt = /* @__PURE__ */ A(
  ({
    image: e,
    name: t,
    hasDrivingRateDiscount: a,
    isEv: n,
    imageHorizontalPadding: r,
    isFirstItem: i = !1,
    isLastItem: l = !1,
    style: c,
    className: d,
    ...o
  }, m) => {
    const { t: f } = Y(), v = a && !n;
    return /* @__PURE__ */ s.jsx(
      "div",
      {
        ref: m,
        className: u(H.thumb_area, H.type_has_info, d),
        style: {
          ...i && { paddingLeft: r },
          ...l && { paddingRight: r },
          ...c
        },
        children: /* @__PURE__ */ s.jsxs(b, { className: "pui__thumb", ...o, children: [
          /* @__PURE__ */ s.jsx("div", { className: H.img, style: { backgroundImage: `url(${e})` } }),
          /* @__PURE__ */ s.jsx("div", { className: H.product_area, children: t }),
          v && /* @__PURE__ */ s.jsx("div", { className: H.label_area, children: f(D.carDiscount) }),
          n && /* @__PURE__ */ s.jsxs("div", { className: H.label_area, children: [
            /* @__PURE__ */ s.jsx(as, { className: H.icon, "aria-hidden": "true" }),
            f(D.electricVehicle)
          ] })
        ] })
      }
    );
  }
), ht = /* @__PURE__ */ A(
  ({ height: e, clickCode: t, ...a }, n) => {
    const { t: r } = Y();
    return /* @__PURE__ */ s.jsxs(
      b,
      {
        className: u(ne.btn),
        style: { height: e },
        ref: n,
        ...a,
        ...t && { [x]: t },
        children: [
          /* @__PURE__ */ s.jsx("span", { className: ne.icon_wrapper, children: /* @__PURE__ */ s.jsx(Ye, { className: ne.icon, "aria-hidden": "true" }) }),
          r(D.showMore)
        ]
      }
    );
  }
), ut = /* @__PURE__ */ A(
  ({
    carImages: e,
    FlickingComponent: t,
    sectionMoreButtonProps: a,
    showMoreThreshold: n = 3,
    imageHorizontalPadding: r = 16,
    style: i,
    className: l
  }, c) => {
    if (!e || !(e != null && e.length))
      return null;
    const d = !!(e && e.length > n), o = d && t || ye;
    return /* @__PURE__ */ s.jsx(
      "div",
      {
        ref: c,
        className: u(H.image_area, { [H.type_multi]: d }, l),
        style: { marginRight: -r, marginLeft: -r, ...i },
        children: /* @__PURE__ */ s.jsxs(o, { children: [
          e.map((m, f) => /* @__PURE__ */ s.jsx(
            mt,
            {
              ...m,
              isFirstItem: f === 0,
              isLastItem: !d && f === e.length - 1,
              imageHorizontalPadding: r
            },
            m.id ?? f
          )),
          d && /* @__PURE__ */ s.jsx(ht, { height: 104, ...a })
        ] })
      }
    );
  }
), zt = ut;
export {
  b as A,
  T as F,
  Os as L,
  ae as N,
  Nt as O,
  xt as P,
  Ct as R,
  Mt as S,
  Et as T,
  _t as V,
  yt as a,
  bt as b,
  gs as c,
  At as d,
  St as e,
  Ot as f,
  Ds as g,
  Dt as h,
  Lt as i,
  xs as j,
  zt as k,
  rs as l,
  is as m,
  cs as n,
  ls as o,
  u as p,
  We as q,
  Ue as r
};
